(function () {
    'use strict';

    angular
        .module('app')
        .controller('SMSActivitiesDialogCtrl', SMSActivitiesDialogCtrl);

    SMSActivitiesDialogCtrl.$inject = [
        'HistoryService',
        'SystemService',
        'DialogInstance',
        'smsId'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for displaying history events linked to the SMS
     *
     * @param {int} smsId - The id of the SMS for which the history will be shown
     */
    function SMSActivitiesDialogCtrl(
        HistoryService,
        SystemService,
        DialogInstance,
        smsId) {

        /* jshint validthis:true */
        var vm = this;
        vm.close = close;
        vm.getFormattedDate = getFormattedDate;
        vm.loading = true;
        vm.title = 'SMS History';

        activate();

        function activate() {
            HistoryService.getHistoryForItem({ masterRecordId: smsId })
                .then(getHistoryOk, getHistoryError)
                .finally(function () {
                    vm.loading = false;
                });

            function getHistoryOk(data) {
                vm.history = data.Items;
            }

            function getHistoryError(response) {
                vm.error = 'Error fetching history.';
            }
        }

        function getFormattedDate(dateString) {
            return SystemService.getFormattedDate(dateString);
        }

        function close() {
            DialogInstance.ok();
        }
    }
})();
